import React, {useEffect, useState} from 'react';
import axios from "axios";
import {API_BASE_URL} from "../../config";
import {useParams} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import Button from "../Elements/Button";

const SectionTechniqueDetailsContactTechnique = () => {
    // Initialize state with empty fields.

    let {id} = useParams(); // Get the 'id' parameter from the URL
    id = parseInt(id);
    const [data, setData] = useState({
        firstname: '',
        lastname: '',
        mail: '',
        phone: '',
        factory: '',
        responsable: ''
    });

    // Fetch technical partner record using its id.
    useEffect(() => {
        if (!id) return; // If no id provided, skip fetching.
        axios
            .post(`${API_BASE_URL}/get_customer_technical_partner/`, {id})
            .then((res) => {

                const result = res.data.result;
                // If result is an array, use the first element; otherwise, use result directly.
                const fetchedData = Array.isArray(result) ? result[0] : result;
                setData({
                    firstname: fetchedData.firstname || '',
                    // Use either lastname or name field from the backend.
                    lastname: fetchedData.lastname || fetchedData.name || '',
                    mail: fetchedData.mail || '',
                    phone: fetchedData.phone || '',
                    factory: fetchedData.factory || '',
                    responsable: fetchedData.responsable || ''
                });
            })
            .catch((err) => console.error('Error fetching technical data:', err));
    }, [id]);

    // Handle input changes.
    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    };

    // Save function calls the new endpoint.
    const handleSave = () => {
        axios
            .post(`${API_BASE_URL}/set_customer_technical_partner/`, {id, ...data})
            .then((res) => {
                toast.success("Contact technique modifié.");
                console.log('Technical partner saved:', res.data);
                // Optionally, update state with any returned info (like a new id after insertion).
            })
            .catch((err) => {

                toast.error("Une erreur est survenue lors de l'enregistrement.");
                console.error('Error saving technical data:', err)
            });
    };

    return (
        <>
            <label className={"text-left mb-20 mt-0 pt-0"}>
                <h3 className={"color-third"}>Contact technique</h3>
            </label>
            <div className={"h-separator mt-20"} />

            <ToastContainer position="bottom-right" autoClose={3000}/>
            <div className="" style={{width: "unset", maxWidth: "unset", padding: 0, marginTop: 20}}>
                <div className={"display-flex gap-20 w-100 flex-direction-column mb-20"}>
                    <h4 className={"color-third"}>Qui est-ce ?</h4>
                    <div className={"display-flex flex-direction-column gap-20"}>
                        <div className={"display-flex flex-direction-column w-100 gap-10"}>
                            <select
                                className={"input p-10"}
                                name="responsable" // <-- this name will be used as the key in setData
                                onChange={handleChange}
                                value={data.responsable || ""}
                            >{console.log(data.responsable)}
                                <option value="">-- Sélectionner --</option>
                                <option value="solution_digitale">Service Externe remplacé par Solution Digitale
                                </option>
                                <option value="service_externe_client">Service informatique Externe du client</option>
                                <option value="responsable_interne">Responsable informatique interne</option>
                                <option value="client">Le client</option>
                            </select>
                        </div>

                        <div className={"display-flex gap-20"}>
                            <div className={"display-flex flex-direction-column w-100 gap-10"}>

                                <strong className={"text-left color-third"}>Entreprise</strong>
                                <input
                                    type="text"
                                    name="factory"
                                    value={data.factory}
                                    onChange={handleChange}
                                    placeholder="Par ex. Solution Digitale SA"
                                    className="input p-10"
                                />
                            </div>
                            <div className={"display-flex flex-direction-column w-100 gap-10"}>

                                <strong className={"text-left color-third"}>Prénom</strong>
                                <input
                                    type="text"
                                    name="firstname"
                                    value={data.firstname}
                                    onChange={handleChange}
                                    placeholder="John"
                                    className="input p-10"
                                />
                            </div>


                            <div className={"display-flex flex-direction-column w-100 gap-10"}>

                                <strong className={"text-left color-third"}>Nom</strong>
                                <input
                                    type="text"
                                    name="lastname"
                                    value={data.lastname}
                                    onChange={handleChange}
                                    placeholder="Doe"
                                    className="input p-10"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"text-left mb-20 display-flex flex-direction-column gap-10"}>
                    <strong className={"text-left color-third"}>Email</strong>
                    <input
                        type="text"
                        name="mail"
                        value={data.mail}
                        onChange={handleChange}
                        placeholder="info@solution-digitale.ch"
                        className="input p-10"
                    /></div>
                <div className={"text-left mb-20 display-flex flex-direction-column gap-10"}>
                    <strong className={"text-left color-third"}>N° de téléphone</strong>
                    <input
                        type="text"
                        name="phone"
                        value={data.phone}
                        onChange={handleChange}
                        placeholder="021/907.87.87"
                        className="input p-10"
                    />
                </div>



                <Button onClick={handleSave} icon={"fa-floppy-disk"}
                        label={"Enregistrer"}
                        textClassNames={"bg-third text-white btn-save"}
                        iconBackground={'bg-fifth'} disableLink/>
            </div>
        </>
    );
};

export default SectionTechniqueDetailsContactTechnique;
